import { Box, useColorModeValue } from "@chakra-ui/react";
import { useDateCalendarMode } from "../../hooks/useDateCalendarMode";

const OPTION_WIDTH = "40px";

/**
 * Single global AD/BS switch — mount this once (e.g. in the app navbar).
 * Every date field in the app reads the same shared preference, so flipping
 * this one control changes every field at once.
 */
export function DateCalendarModeSwitch() {
  const [mode, setMode] = useDateCalendarMode();
  const trackBg = useColorModeValue("surface.100", "whiteAlpha.100");
  const inactiveColor = useColorModeValue("surface.600", "whiteAlpha.700");

  return (
    <Box
      position="relative"
      display="inline-flex"
      bg={trackBg}
      borderRadius="full"
      p="2px"
      flexShrink={0}
    >
      <Box
        position="absolute"
        top="2px"
        bottom="2px"
        left={mode === "AD" ? "2px" : `calc(${OPTION_WIDTH} + 2px)`}
        w={OPTION_WIDTH}
        bg="primary.500"
        borderRadius="full"
        transition="left 0.2s cubic-bezier(0.4, 0, 0.2, 1)"
      />
      {(["AD", "BS"] as const).map((option) => (
        <Box
          key={option}
          as="button"
          type="button"
          position="relative"
          zIndex={1}
          w={OPTION_WIDTH}
          py="6px"
          fontSize="sm"
          fontWeight="700"
          textAlign="center"
          cursor="pointer"
          color={mode === option ? "white" : inactiveColor}
          transition="color 0.2s ease"
          onClick={() => setMode(option)}
        >
          {option}
        </Box>
      ))}
    </Box>
  );
}
